import { commentService } from '@/services/comments.service';
import { useQuery } from '@tanstack/react-query';


export const useGetBlogComments = (pageNumber: number,blogId:number) => {
    const { data, isLoading, isError, error, refetch, isPending } = useQuery({
        queryKey: ['comment', pageNumber],
        queryFn: () => commentService.getOneBlogComments(blogId,pageNumber),
    });
    return {
        comments: data?.data ?? [],
        isLoading,
        isError,
        error,
        refetch,
        totalPages: data?.pageCount,
        isPending,
    };
};
